<template>
  <div id="dataset_compare">
    <h2>Dataset Compare</h2>
    <div style="background-color: #FFFFFF; height: 50px;padding: 5px 0 5px 0">
      <span style="padding: 0 20px 0 20px;font-size: 20px">Gene:</span>
      <el-input
          style="width: 100px;font-size: 14px"
          size="mini"
          placeholder="gene"
          v-for="(item, index) in gene_json"
          :key="index"
          v-model="item.gene"
      ></el-input>
      <el-button size="mini" type="info" round style="margin: 0 0 0 10px" @click="add"><span style="font-size: 20px">add</span></el-button>
      <el-button size="mini" type="info" round style="margin: 0 0 0 10px" @click="remove"><span style="font-size: 20px">remove</span></el-button>
<!--      filterable-->
<!--      <el-select v-model="Gene"-->
<!--                 clearable-->
<!--                 multiple-->
<!--                 :multiple-limit="5"-->
<!--                 placeholder="please select">-->
<!--        <el-option-->
<!--            v-for="(item,index) in genelist"-->
<!--            :key="index"-->
<!--            :label="item"-->
<!--            :value="item">-->
<!--        </el-option>-->
<!--      </el-select>-->
      <el-button size="mini" type="info" round style="margin: 0 0 0 10px" @click="changeSummit"><span style="font-size: 20px">submit</span></el-button>
    </div>

    <div class="container" id="compare1">
      <div class="left">
        <div>
          <span>Type:</span>
          <el-select v-model="type_select[0]"
                     clearable
                     filterable
                     size="mini"
                     placeholder="please select">
            <el-option
                v-for="item in type_list[0]"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <el-button size="mini" type="info" round style="margin-left: 10px" @click="changeSelect(0)">submit</el-button>
        </div>

        <div id="groundtruth1" style="height: 400px;width: 400px;display: inline">
          <img :src="groundtruth_source[0]" width="350px" alt=""></div>

        <div id="compare1_echart" style="height: 400px;width: 400px;display: inline"/>

        <div id="compare1_classification" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare1_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare1_fine_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare1_celltype" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare1_major" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare1_minor" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare1_subset" style="height: 400px;width: 400px;display: inline"></div>
      </div>
      <div class="right">
        <div style="width: 2000px;height: 400px;display: flex;flex-wrap: nowrap;justify-content: flex-start;" id="compare1_right">
          <div id="compare1_gene1" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare1_gene2" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare1_gene3" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare1_gene4" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare1_gene5" style="height: 400px;width: 400px;display: inline"></div>
        </div>
      </div>
    </div>

    <div class="container" id="compare2">
      <div class="left">
        <div>
          <span>Type:</span>
          <el-select v-model="type_select[1]"
                     clearable
                     filterable
                     size="mini"
                     placeholder="please select">
            <el-option
                v-for="item in type_list[1]"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <el-button size="mini" type="info" round style="margin-left: 10px" @click="changeSelect(1)">submit</el-button>
        </div>

        <div id="groundtruth2" style="height: 400px;width: 400px;display: inline">
          <img :src="groundtruth_source[1]" width="350px" alt=""></div>
        <div id="compare2_echart" style="height: 400px;width: 400px;display: inline"/>

        <div id="compare2_classification" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare2_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare2_fine_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare2_celltype" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare2_major" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare2_minor" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare2_subset" style="height: 400px;width: 400px;display: inline"></div>
      </div>
      <div class="right">
        <div style="width: 2000px;height: 400px;display: flex;flex-wrap: nowrap;justify-content: flex-start;" id="compare2_right">
          <div id="compare2_gene1" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare2_gene2" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare2_gene3" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare2_gene4" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare2_gene5" style="height: 400px;width: 400px;display: inline"></div>
        </div>
      </div>
    </div>

    <div class="container" id="compare3">
      <div class="left">
        <div>
          <span>Type:</span>
          <el-select v-model="type_select[2]"
                     clearable
                     filterable
                     size="mini"
                     placeholder="please select">
            <el-option
                v-for="item in type_list[2]"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <el-button size="mini" type="info" round style="margin-left: 10px" @click="changeSelect(2)">submit</el-button>
        </div>

        <div id="groundtruth3" style="height: 400px;width: 400px;display: inline">
          <img :src="groundtruth_source[2]" width="350px" alt=""></div>
        <div id="compare3_echart" style="height: 400px;width: 400px;display: inline"/>

        <div id="compare3_classification" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare3_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare3_fine_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare3_celltype" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare3_major" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare3_minor" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare3_subset" style="height: 400px;width: 400px;display: inline"></div>
      </div>
      <div class="right">
        <div style="width: 2000px;height: 400px;display: flex;flex-wrap: nowrap;justify-content: flex-start;" id="compare3_right">
          <div id="compare3_gene1" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare3_gene2" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare3_gene3" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare3_gene4" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare3_gene5" style="height: 400px;width: 400px;display: inline"></div>
        </div>
      </div>
    </div>

    <div class="container" id="compare4">
      <div class="left">
        <div>
          <span>Type:</span>
          <el-select v-model="type_select[3]"
                     clearable
                     filterable
                     size="mini"
                     placeholder="please select">
            <el-option
                v-for="item in type_list[3]"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <el-button size="mini" type="info" round style="margin-left: 10px" @click="changeSelect(3)">submit</el-button>
        </div>

        <div id="groundtruth4" style="height: 400px;width: 400px;display: inline">
          <img :src="groundtruth_source[3]" width="350px" alt=""></div>
        <div id="compare4_echart" style="height: 400px;width: 400px;display: inline"/>

        <div id="compare4_classification" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare4_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare4_fine_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare4_celltype" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare4_major" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare4_minor" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare4_subset" style="height: 400px;width: 400px;display: inline"></div>
      </div>
      <div class="right">
        <div style="width: 2800px;height: 400px;display: flex;flex-wrap: nowrap;justify-content: flex-start;" id="compare4_right">
          <div id="compare4_gene1" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare4_gene2" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare4_gene3" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare4_gene4" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare4_gene5" style="height: 400px;width: 400px;display: inline"></div>
        </div>
      </div>
    </div>

    <div class="container" id="compare5">
      <div class="left">
        <div>
          <span>Type:</span>
          <el-select v-model="type_select[4]"
                     clearable
                     filterable
                     size="mini"
                     placeholder="please select">
            <el-option
                v-for="item in type_list[4]"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <el-button size="mini" type="info" round style="margin-left: 10px" @click="changeSelect(4)">submit</el-button>
        </div>

        <div id="groundtruth5" style="height: 400px;width: 400px;display: inline">
          <img :src="groundtruth_source[4]" width="350px" alt=""></div>
        <div id="compare5_echart" style="height: 400px;width: 400px;display: inline"/>

        <div id="compare5_classification" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare5_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare5_fine_anno_type" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare5_celltype" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare5_major" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare5_minor" style="height: 400px;width: 400px;display: inline"></div>
        <div id="compare5_subset" style="height: 400px;width: 400px;display: inline"></div>
      </div>
      <div class="right">
        <div style="width: 2800px;height: 400px;display: flex;flex-wrap: nowrap;justify-content: flex-start;" id="compare5_right">
          <div id="compare5_gene1" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare5_gene2" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare5_gene3" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare5_gene4" style="height: 400px;width: 400px;display: inline"></div>
          <div id="compare5_gene5" style="height: 400px;width: 400px;display: inline"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "Compare",
  data(){
    return{
      Gene: [],
      genelist: [],
      type_select: ['','','','',''],
      type_list: [[],[],[],[],[]],
      all_genes: [
          [],[],[],[],[]
      ],
      groundtruth_source: [],
      selectedDataset: [],
      Expression: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      data: [
          [],
          [],
          [],
          [],
          []
      ],
      position: [
          [],
          [],
          [],
          [],
          []
      ],
      COLOR_ALL: [
        '#37A2DA',
        '#e06343',
        '#37a354',
        '#b55dba',
        '#b5bd48',
        '#8378EA',
        '#96BFFF',
        '#E72178',
        '#354E6C','#EAAC31',
        '#EAD2AE',
        '#127678','#30B5A4','#B4D9D2',
        '#354581','#FFE074',
        '#E03C79','#88C1B8',
        '#FC6746','#F5B307','#008186'
      ],
      echart_info1: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      echart_info2: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      echart_info3: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      echart_info4: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      echart_info5: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      gene_json: [
        {
          gene: "",
        },
      ],
    }
  },
  props:{
    datasetInfo: Array
  },
  mounted() {
    this.selectedDataset = this.datasetInfo
    if(this.selectedDataset.length > 5){
      this.selectedDataset = this.selectedDataset.slice(0,5)
    }
    // this.initEcharts()
    this.$nextTick(function () {
      this.getGroundTruth()
      this.getDatasetData()
      this.initMainEcharts()
    })
    // this.getGeneList()
    // setTimeout(() => {
    //   console.log(this.all_genes)
    //   this.mergeGeneList()
    // },2000)
  },
  methods: {
    getGroundTruth(){
      let _this = this
      for (let i=0; i<_this.selectedDataset.length; i++){
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/dataset/groundtruth/'
            + _this.selectedDataset[i].datasetID + '/' + _this.selectedDataset[i].name)
            .then(function (response){
              // console.log(response)
              if (response.data !== ""){
                _this.groundtruth_source.push(response.data)
              }
            })
      }
    },
    getGeneList(){
      let _this = this
      for (let i=0; i<_this.selectedDataset.length; i++){
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/allgenes/'
            + _this.selectedDataset[i].datasetID + '/' + _this.selectedDataset[i].name)
            .then(function (response){
              console.log(response)
              _this.all_genes[i] = response.data
            })
      }
    },
    mergeGeneList(){
      let _this = this
      _this.genelist = _this.genelist.concat(_this.all_genes[0], _this.all_genes[1], _this.all_genes[2], _this.all_genes[3], _this.all_genes[4])
      console.log(_this.genelist)
      _this.genelist = Array.from(new Set(_this.genelist))
      console.log("genelist:")
      console.log(_this.genelist)
    },
    getDatasetData(){
      let _this = this
      _this.clearData()
      for (let i=5; i>_this.selectedDataset.length; i--){
        let tempstr = 'compare' + i
        document.getElementById(tempstr).style.display = 'none';
      }
      for (let i=0; i<_this.selectedDataset.length; i++){
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/dataset/anno_position/'
            + _this.selectedDataset[i].datasetID + '/' + _this.selectedDataset[i].name)
            .then(function (response){
              // console.log(response)
              _this.data[i] = eval('(' + response.data.anno + ')')
              _this.position[i] = eval('(' + response.data.position + ')')
              let haveClassification = Object.prototype.hasOwnProperty.call(_this.data[i][0], "Classification")
              let haveAnnot = Object.prototype.hasOwnProperty.call(_this.data[i][0], "annot_type")
              let haveFineAnnot = Object.prototype.hasOwnProperty.call(_this.data[i][0], "fine_annot_type")
              let haveCelltype = Object.prototype.hasOwnProperty.call(_this.data[i][0], "celltype")
              let haveMajor = Object.prototype.hasOwnProperty.call(_this.data[i][0], "celltype_major")
              let haveMinor = Object.prototype.hasOwnProperty.call(_this.data[i][0], "celltype_minor")
              let haveSubset = Object.prototype.hasOwnProperty.call(_this.data[i][0], "celltype_subset")
              // console.log(haveAnnot)
              // console.log(haveFineAnnot)
              // console.log(haveClassification)
              // console.log(haveCelltype)
              // console.log(haveMajor)
              // console.log(haveMinor)
              // console.log(haveSubset)
              _this.initEchartsInfoLabel(i, haveAnnot, haveFineAnnot, haveClassification)
              _this.initEchartsInfoPre(i, haveCelltype, haveMajor, haveMinor, haveSubset)
              _this.initList(i, haveAnnot, haveFineAnnot, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset)
              _this.initEcharts(i, haveAnnot, haveFineAnnot, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset)
            }).catch(function () {
              _this.$message.error("Sorry, "+_this.selectedDataset[i].name+" do not exist, please try others!");
              _this.showDatasetCompare = false;
              return
        })
      }
    },
    clearData(){
      this.Gene.length = 0
      this.genelist.length = 0
      let temp = {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      }
      this.echart_info1 = temp
      this.echart_info2 = temp
      this.echart_info3 = temp
      this.echart_info4 = temp
      this.echart_info5 = temp
      this.gene_json.length  = 0
      this.gene_json.push({ gene: ""})
      this.groundtruth_source.length = 0
      for (let i = 0; i<25;i++){
        this.Expression[i].length = 0
      }
      for (let i = 0; i< 5;i++){
        this.all_genes[i].length = 0
        this.data[i].length = 0
        this.position[i].length = 0
      }
    },
    initMainEcharts(){
      let option;
      const schema = [
        { name: 'x', index: 0, text: 'x' },
        { name: 'y', index: 1, text: 'y' },
        { name: 'gene', index: 2, text: 'gene' },
        { name: 'expression', index: 3, text: 'expression' },
      ];
      option = {
        color: ['#ff0000'],
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              title: "save",
              name: "marker.png",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        // grid: {
        //   right: '15%',
        // },
        visualMap: [
          {
            right: 0,
            bottom: '40%',
            dimension: 3,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:0,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 10,
            itemHeight: 120,
            align:"auto",
            text: ['expression'],
            textGap: 20,
            inRange: {
              color: ['#d9d9d9','blue']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['#d9d9d9', 'blue']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + schema[2].text + '：' + value[2]
                + '</div>'
                + schema[0].text + '：' + value[0] + '<br>'
                + schema[1].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            symbolSize: 10,
            data: [
              [1, 1,'test',20],
            ],
            type: 'scatter'
          }
        ]
      };
      for (let i=0;i<5;i++){
        for (let j=0;j<5;j++){
          let tempstr = "compare" + (i+1) + "_gene" + (j+1);
          let myChartDom = document.getElementById(tempstr);
          const myChart = echarts.init(myChartDom);
          option && myChart.setOption(option);
        }
      }
    },
    initEchartsInfoLabel(index, haveAnno, haveFineAnno, haveClassification){
      let _this = this
      let temp_echart_info = {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
      }
      let temp_Anno;
      let temp_FineAnno;
      let temp_types_classification;
      if (haveAnno){
        temp_Anno = []
        temp_echart_info.annot_type_info.source.push(['type','x','y'])
      }
      if (haveFineAnno){
        temp_FineAnno = []
        temp_echart_info.fine_annot_type_info.source.push(['type','x','y'])
      }
      if (haveClassification){
        temp_types_classification = []
        temp_echart_info.classification_info.source.push(['type','x','y'])
      }
      for (let i=0; i< _this.data[index].length; i++) {
        let temp_index = _this.position[index].findIndex(item => item.spot === _this.data[index][i].spot)
        if (temp_index !== -1 && _this.position[index][temp_index].x !== '' && _this.position[index][temp_index].x !== null) {
          if (haveAnno){
            temp_echart_info.annot_type_info.source.push([_this.data[index][i].annot_type, _this.position[index][temp_index].x, _this.position[index][temp_index].y])
          }
          if (haveFineAnno){
            temp_echart_info.fine_annot_type_info.source.push([_this.data[index][i].fine_annot_type, _this.position[index][temp_index].x, _this.position[index][temp_index].y])
          }
          if (haveClassification){
            temp_echart_info.classification_info.source.push([_this.data[index][i].Classification, _this.position[index][temp_index].x, _this.position[index][temp_index].y])
          }

          if (haveAnno && !temp_Anno.includes(_this.data[index][i].annot_type)) {
            temp_Anno.push(_this.data[index][i].annot_type)
          }
          if (haveFineAnno && !temp_FineAnno.includes(_this.data[index][i].fine_annot_type)) {
            temp_FineAnno.push(_this.data[index][i].fine_annot_type)
          }
          if (haveClassification && !temp_types_classification.includes(_this.data[index][i].Classification)) {
            temp_types_classification.push(_this.data[index][i].Classification)
          }
        }
      }
      if (_this.data[index].length > 5000){
        temp_echart_info.annot_type_info.spotSize = 2
        temp_echart_info.fine_annot_type_info.spotSize = 2
        temp_echart_info.classification_info.spotSize = 2
      }
      else {
        temp_echart_info.annot_type_info.spotSize = 4
        temp_echart_info.fine_annot_type_info.spotSize = 4
        temp_echart_info.classification_info.spotSize = 4
      }
      if (haveAnno){
        temp_echart_info.annot_type_info.types = temp_Anno
        for (let i=0; i< temp_echart_info.annot_type_info.types.length; i++){
          temp_echart_info.annot_type_info.tip.push({
            value: temp_echart_info.annot_type_info.types[i],
            label: temp_echart_info.annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveFineAnno){
        temp_echart_info.fine_annot_type_info.types = temp_FineAnno
        for (let i=0; i< temp_echart_info.fine_annot_type_info.types.length; i++){
          temp_echart_info.fine_annot_type_info.tip.push({
            value: temp_echart_info.fine_annot_type_info.types[i],
            label: temp_echart_info.fine_annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveClassification) {
        temp_echart_info.classification_info.types = temp_types_classification
        for (let i=0; i< temp_echart_info.classification_info.types.length; i++){
          temp_echart_info.classification_info.tip.push({
            value: temp_echart_info.classification_info.types[i],
            label: temp_echart_info.classification_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      switch (index) {
        case 0:
          _this.echart_info1.classification_info = temp_echart_info.classification_info
          _this.echart_info1.annot_type_info = temp_echart_info.annot_type_info
          _this.echart_info1.fine_annot_type_info = temp_echart_info.fine_annot_type_info
          break;
        case 1:
          _this.echart_info2.classification_info = temp_echart_info.classification_info
          _this.echart_info2.annot_type_info = temp_echart_info.annot_type_info
          _this.echart_info2.fine_annot_type_info = temp_echart_info.fine_annot_type_info
          break;
        case 2:
          _this.echart_info3.classification_info = temp_echart_info.classification_info
          _this.echart_info3.annot_type_info = temp_echart_info.annot_type_info
          _this.echart_info3.fine_annot_type_info = temp_echart_info.fine_annot_type_info
          break;
        case 3:
          _this.echart_info4.classification_info = temp_echart_info.classification_info
          _this.echart_info4.annot_type_info = temp_echart_info.annot_type_info
          _this.echart_info4.fine_annot_type_info = temp_echart_info.fine_annot_type_info
          break;
        case 4:
          _this.echart_info5.classification_info = temp_echart_info.classification_info
          _this.echart_info5.annot_type_info = temp_echart_info.annot_type_info
          _this.echart_info5.fine_annot_type_info = temp_echart_info.fine_annot_type_info
          break;
      }
      // console.log(_this.echart_info.classification_info.tip)
    },
    initEchartsInfoPre(index, haveCelltype, haveMajor, haveMinor, haveSubset){
      let _this = this
      let temp_echart_info = {
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      }
      let temp_Celltype;
      let temp_Major;
      let temp_Minor;
      let temp_Subset;
      if (haveCelltype){
        temp_Celltype = []
        temp_echart_info.celltype_info.source.push(['type','x','y'])
      }
      if (haveMajor){
        temp_Major = []
        temp_echart_info.major_info.source.push(['type','x','y'])
      }
      if (haveMinor){
        temp_Minor = []
        temp_echart_info.minor_info.source.push(['type','x','y'])
      }
      if (haveSubset){
        temp_Subset = []
        temp_echart_info.subset_info.source.push(['type','x','y'])
      }
      for (let i=0; i< _this.data[index].length; i++) {
        let temp_index = _this.position[index].findIndex(item => item.spot === _this.data[index][i].spot)
        if (temp_index !== -1 && _this.position[index][temp_index].x !== '' && _this.position[index][temp_index].x !== null) {
          if (haveCelltype){
            temp_echart_info.celltype_info.source.push([_this.data[index][i].celltype, _this.position[index][temp_index].x, _this.position[index][temp_index].y])
          }
          if (haveMajor){
            temp_echart_info.major_info.source.push([_this.data[index][i].celltype_major, _this.position[index][temp_index].x, _this.position[index][temp_index].y])
          }
          if (haveMinor){
            temp_echart_info.minor_info.source.push([_this.data[index][i].celltype_minor, _this.position[index][temp_index].x, _this.position[index][temp_index].y])
          }
          if (haveSubset){
            temp_echart_info.subset_info.source.push([_this.data[index][i].celltype_subset, _this.position[index][temp_index].x, _this.position[index][temp_index].y])
          }

          if (haveCelltype && !temp_Celltype.includes(_this.data[index][i].celltype)) {
            temp_Celltype.push(_this.data[index][i].celltype)
          }
          if (haveMajor && !temp_Major.includes(_this.data[index][i].celltype_major)) {
            temp_Major.push(_this.data[index][i].celltype_major)
          }
          if (haveMinor && !temp_Minor.includes(_this.data[index][i].celltype_minor)) {
            temp_Minor.push(_this.data[index][i].celltype_minor)
          }
          if (haveSubset && !temp_Subset.includes(_this.data[index][i].celltype_subset)) {
            temp_Subset.push(_this.data[index][i].celltype_subset)
          }
        }
      }
      if (_this.data[index].length > 5000){
        temp_echart_info.celltype_info.spotSize = 2
        temp_echart_info.major_info.spotSize = 2
        temp_echart_info.minor_info.spotSize = 2
        temp_echart_info.subset_info.spotSize = 2
      }
      else {
        temp_echart_info.celltype_info.spotSize = 4
        temp_echart_info.major_info.spotSize = 4
        temp_echart_info.minor_info.spotSize = 4
        temp_echart_info.subset_info.spotSize = 4
      }
      if (haveCelltype){
        temp_echart_info.celltype_info.types = temp_Celltype
        for (let i=0; i< temp_echart_info.celltype_info.types.length; i++){
          temp_echart_info.celltype_info.tip.push({
            value: temp_echart_info.celltype_info.types[i],
            label: temp_echart_info.celltype_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveMajor){
        temp_echart_info.major_info.types = temp_Major
        for (let i=0; i< temp_echart_info.major_info.types.length; i++){
          temp_echart_info.major_info.tip.push({
            value: temp_echart_info.major_info.types[i],
            label: temp_echart_info.major_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveMinor){
        temp_echart_info.minor_info.types = temp_Minor
        for (let i=0; i< temp_echart_info.minor_info.types.length; i++){
          temp_echart_info.minor_info.tip.push({
            value: temp_echart_info.minor_info.types[i],
            label: temp_echart_info.minor_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveSubset){
        temp_echart_info.subset_info.types = temp_Subset
        for (let i=0; i< temp_echart_info.subset_info.types.length; i++){
          temp_echart_info.subset_info.tip.push({
            value: temp_echart_info.subset_info.types[i],
            label: temp_echart_info.subset_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (index === 0) {
        _this.echart_info1.celltype_info = temp_echart_info.celltype_info
        _this.echart_info1.major_info = temp_echart_info.major_info
        _this.echart_info1.minor_info = temp_echart_info.minor_info
        _this.echart_info1.subset_info = temp_echart_info.subset_info
      } else if(index === 1) {
        _this.echart_info2.celltype_info = temp_echart_info.celltype_info
        _this.echart_info2.major_info = temp_echart_info.major_info
        _this.echart_info2.minor_info = temp_echart_info.minor_info
        _this.echart_info2.subset_info = temp_echart_info.subset_info
      } else if(index === 2) {
        _this.echart_info3.celltype_info = temp_echart_info.celltype_info
        _this.echart_info3.major_info = temp_echart_info.major_info
        _this.echart_info3.minor_info = temp_echart_info.minor_info
        _this.echart_info3.subset_info = temp_echart_info.subset_info
      } else if(index === 3) {
        _this.echart_info4.celltype_info = temp_echart_info.celltype_info
        _this.echart_info4.major_info = temp_echart_info.major_info
        _this.echart_info4.minor_info = temp_echart_info.minor_info
        _this.echart_info4.subset_info = temp_echart_info.subset_info
      } else if(index === 4) {
        _this.echart_info5.celltype_info = temp_echart_info.celltype_info
        _this.echart_info5.major_info = temp_echart_info.major_info
        _this.echart_info5.minor_info = temp_echart_info.minor_info
        _this.echart_info5.subset_info = temp_echart_info.subset_info
      }
      console.log(index)
      console.log(_this.data)
      console.log(_this.echart_info1.celltype_info)
      console.log(_this.echart_info2.celltype_info)
      console.log(_this.echart_info3.celltype_info)
      // console.log(_this.echart_info.classification_info.tip)
    },
    initList(index, haveAnno, haveFineAnno, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset){
      let _this = this
      _this.type_list[index].push("image")
      if (haveAnno) {_this.type_list[index].push("annotation")}
      if (haveFineAnno) {_this.type_list[index].push("fine annotation")}
      if (haveClassification) {_this.type_list[index].push("domain")}
      if (haveCelltype) {_this.type_list[index].push("cell type")}
      if (haveMajor) {_this.type_list[index].push("cell type major")}
      if (haveMinor) {_this.type_list[index].push("cell type minor")}
      if (haveSubset) {_this.type_list[index].push("cell type subset")}
      _this.type_select[index] = _this.type_list[index][0]
      // _this.initEchart('compare' + (index + 1) + '_echart', index)
    },
    initEcharts(index, haveAnno, haveFineAnno, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset){
      let _this = this
      let width = 0;
      switch (index) {
        case 0:
          if (haveAnno){
            width = width + 400;
            let compare1_anno_type_div = document.getElementById('compare1_anno_type');
            const myChart_compare1_anno_type = echarts.init(compare1_anno_type_div);
            let option;
            option = {
              title:{
                text: 'annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info1.annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info1.annot_type_info.tip,
                // formatter: function (value) {
                //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                // },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info1.annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info1.annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare1_anno_type.setOption(option);
          }else {
            document.getElementById('compare1_anno_type').style.display = 'none';
          }
          if (haveFineAnno){
            width = width + 400;
            let compare1_compare1_fine_anno_type_div = document.getElementById('compare1_fine_anno_type');
            const myChart_compare1_fine_anno_type = echarts.init(compare1_compare1_fine_anno_type_div);
            let option;
            option = {
              title:{
                text: 'fine annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info1.fine_annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info1.fine_annot_type_info.tip,
                // formatter: function (value) {
                //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                // },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info1.fine_annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info1.fine_annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare1_fine_anno_type.setOption(option);
          }else {
            document.getElementById('compare1_fine_anno_type').style.display = 'none';
          }
          if (haveClassification){
            width = width + 400;
            let compare1_classification_div = document.getElementById('compare1_classification');
            const myChart_compare1_classification_type = echarts.init(compare1_classification_div);
            let option;
            option = {
              title:{
                text: 'classification type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info1.classification_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info1.classification_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info1.classification_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info1.classification_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare1_classification_type.setOption(option);
          }else {
            document.getElementById('compare1_classification').style.display = 'none';
          }
          if (haveCelltype){
            width = width + 400;
            let compare1_celltype_div = document.getElementById('compare1_celltype');
            const myChart_compare1_celltype_type = echarts.init(compare1_celltype_div);
            let option;
            option = {
              title:{
                text: 'celltype',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info1.celltype_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info1.celltype_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info1.celltype_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info1.celltype_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare1_celltype_type.setOption(option);
          }else {
            document.getElementById('compare1_celltype').style.display = 'none';
          }
          if (haveMajor){
            width = width + 400;
            let compare1_major_div = document.getElementById('compare1_major');
            const myChart_compare1_major_type = echarts.init(compare1_major_div);
            let option;
            option = {
              title:{
                text: 'celltype major',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info1.major_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info1.major_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info1.major_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info1.major_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare1_major_type.setOption(option);
          }else {
            document.getElementById('compare1_major').style.display = 'none';
          }
          if (haveMinor){
            width = width + 400;
            let compare1_minor_div = document.getElementById('compare1_minor');
            const myChart_compare1_minor_type = echarts.init(compare1_minor_div);
            let option;
            option = {
              title:{
                text: 'celltype minor',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info1.minor_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info1.minor_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info1.minor_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info1.minor_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare1_minor_type.setOption(option);
          }else {
            document.getElementById('compare1_minor').style.display = 'none';
          }
          if (haveSubset){
            width = width + 400;
            let compare1_subset_div = document.getElementById('compare1_subset');
            const myChart_compare1_subset_type = echarts.init(compare1_subset_div);
            let option;
            option = {
              title:{
                text: 'celltype subset',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info1.subset_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info1.subset_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info1.subset_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info1.subset_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare1_subset_type.setOption(option);
          }else {
            document.getElementById('compare1_subset').style.display = 'none';
          }
          document.getElementById('compare1_right').style.width = width + 'px';
          break;
        case 1:
          if (haveAnno){
            width = width + 400;
            let compare2_anno_type_div = document.getElementById('compare2_anno_type');
            const myChart_compare2_anno_type = echarts.init(compare2_anno_type_div);
            let option;
            option = {
              title:{
                text: 'annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info2.annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info2.annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info2.annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info2.annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare2_anno_type.setOption(option);
          }else {
            document.getElementById('compare2_anno_type').style.display = 'none';
          }
          if (haveFineAnno){
            width = width + 400;
            let compare2_fine_anno_type_div = document.getElementById('compare2_fine_anno_type');
            const myChart_compare2_fine_anno_type = echarts.init(compare2_fine_anno_type_div);
            let option;
            option = {
              title:{
                text: 'fine annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info2.fine_annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info2.fine_annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info2.fine_annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info2.fine_annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare2_fine_anno_type.setOption(option);
          }else {
            document.getElementById('compare2_fine_anno_type').style.display = 'none';
          }
          if (haveClassification){
            width = width + 400;
            let compare2_classification_div = document.getElementById('compare2_classification');
            const myChart_compare2_classification_type = echarts.init(compare2_classification_div);
            let option;
            option = {
              title:{
                text: 'classification type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info2.classification_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info2.classification_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info2.classification_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info2.classification_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare2_classification_type.setOption(option);
          }else {
            document.getElementById('compare2_classification').style.display = 'none';
          }
          if (haveCelltype){
            width = width + 400;
            let compare2_celltype_div = document.getElementById('compare2_celltype');
            const myChart_compare2_celltype_type = echarts.init(compare2_celltype_div);
            let option;
            option = {
              title:{
                text: 'celltype',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info2.celltype_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info2.celltype_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info2.celltype_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info2.celltype_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare2_celltype_type.setOption(option);
          }else {
            document.getElementById('compare2_celltype').style.display = 'none';
          }
          if (haveMajor){
            width = width + 400;
            let compare2_major_div = document.getElementById('compare2_major');
            const myChart_compare2_major_type = echarts.init(compare2_major_div);
            let option;
            option = {
              title:{
                text: 'celltype major',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info2.major_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info2.major_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info2.major_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info2.major_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare2_major_type.setOption(option);
          }else {
            document.getElementById('compare2_major').style.display = 'none';
          }
          if (haveMinor){
            width = width + 400;
            let compare2_minor_div = document.getElementById('compare2_minor');
            const myChart_compare2_minor_type = echarts.init(compare2_minor_div);
            let option;
            option = {
              title:{
                text: 'celltype minor',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info2.minor_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info2.minor_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info2.minor_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info2.minor_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare2_minor_type.setOption(option);
          }else {
            document.getElementById('compare2_minor').style.display = 'none';
          }
          if (haveSubset){
            width = width + 400;
            let compare2_subset_div = document.getElementById('compare2_subset');
            const myChart_compare2_subset_type = echarts.init(compare2_subset_div);
            let option;
            option = {
              title:{
                text: 'celltype subset',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info2.subset_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info2.subset_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info2.subset_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info2.subset_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare2_subset_type.setOption(option);
          }else {
            document.getElementById('compare2_subset').style.display = 'none';
          }
          document.getElementById('compare2_right').style.width = width + 'px';
          break;
        case 2:
          if (haveAnno){
            width = width + 400;
            let compare3_anno_type_div = document.getElementById('compare3_anno_type');
            const myChart_compare3_anno_type = echarts.init(compare3_anno_type_div);
            let option;
            option = {
              title:{
                text: 'annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info3.annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info3.annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info3.annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info3.annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare3_anno_type.setOption(option);
          }else {
            document.getElementById('compare3_anno_type').style.display = 'none';
          }
          if (haveFineAnno){
            width = width + 400;
            let compare3_fine_anno_type_div = document.getElementById('compare3_fine_anno_type');
            const myChart_compare3_fine_anno_type = echarts.init(compare3_fine_anno_type_div);
            let option;
            option = {
              title:{
                text: 'fine annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info3.fine_annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info3.fine_annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info3.fine_annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info3.fine_annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare3_fine_anno_type.setOption(option);
          }else {
            document.getElementById('compare3_fine_anno_type').style.display = 'none';
          }
          if (haveClassification){
            width = width + 400;
            let compare3_classification_div = document.getElementById('compare3_classification');
            const myChart_compare3_classification_type = echarts.init(compare3_classification_div);
            let option;
            option = {
              title:{
                text: 'classification type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info3.classification_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info3.classification_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info3.classification_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info3.classification_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare3_classification_type.setOption(option);
          }else {
            document.getElementById('compare3_classification').style.display = 'none';
          }
          if (haveCelltype){
            width = width + 400;
            let compare3_celltype_div = document.getElementById('compare3_celltype');
            const myChart_compare3_celltype_type = echarts.init(compare3_celltype_div);
            let option;
            option = {
              title:{
                text: 'celltype',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info3.celltype_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info3.celltype_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info3.celltype_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info3.celltype_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare3_celltype_type.setOption(option);
          }else {
            document.getElementById('compare3_celltype').style.display = 'none';
          }
          if (haveMajor){
            width = width + 400;
            let compare3_major_div = document.getElementById('compare3_major');
            const myChart_compare3_major_type = echarts.init(compare3_major_div);
            let option;
            option = {
              title:{
                text: 'celltype major',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info3.major_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info3.major_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info3.major_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info3.major_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare3_major_type.setOption(option);
          }else {
            document.getElementById('compare3_major').style.display = 'none';
          }
          if (haveMinor){
            width = width + 400;
            let compare3_minor_div = document.getElementById('compare3_minor');
            const myChart_compare3_minor_type = echarts.init(compare3_minor_div);
            let option;
            option = {
              title:{
                text: 'celltype minor',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info3.minor_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info3.minor_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info3.minor_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info3.minor_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare3_minor_type.setOption(option);
          }else {
            document.getElementById('compare3_minor').style.display = 'none';
          }
          if (haveSubset){
            width = width + 400;
            let compare3_subset_div = document.getElementById('compare3_subset');
            const myChart_compare3_subset_type = echarts.init(compare3_subset_div);
            let option;
            option = {
              title:{
                text: 'celltype subset',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info3.subset_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info3.subset_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info3.subset_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info3.subset_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare3_subset_type.setOption(option);
          }else {
            document.getElementById('compare3_subset').style.display = 'none';
          }
          document.getElementById('compare3_right').style.width = width + 'px';
          break;
        case 3:
          if (haveAnno){
            width = width + 400;
            let compare4_anno_type_div = document.getElementById('compare4_anno_type');
            const myChart_compare4_anno_type = echarts.init(compare4_anno_type_div);
            let option;
            option = {
              title:{
                text: 'annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info4.annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info4.annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info4.annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info4.annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare4_anno_type.setOption(option);
          }else {
            document.getElementById('compare4_anno_type').style.display = 'none';
          }
          if (haveFineAnno){
            width = width + 400;
            let compare4_fine_anno_type_div = document.getElementById('compare4_fine_anno_type');
            const myChart_compare4_fine_anno_type = echarts.init(compare4_fine_anno_type_div);
            let option;
            option = {
              title:{
                text: 'fine annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info4.fine_annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info4.fine_annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info4.fine_annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info4.fine_annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare4_fine_anno_type.setOption(option);
          }else {
            document.getElementById('compare4_fine_anno_type').style.display = 'none';
          }
          if (haveClassification){
            width = width + 400;
            let compare4_classification_div = document.getElementById('compare4_classification');
            const myChart_compare4_classification_type = echarts.init(compare4_classification_div);
            let option;
            option = {
              title:{
                text: 'classification type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info4.classification_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info4.classification_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info4.classification_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info4.classification_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare4_classification_type.setOption(option);
          }else {
            document.getElementById('compare4_classification').style.display = 'none';
          }
          if (haveCelltype){
            width = width + 400;
            let compare4_celltype_div = document.getElementById('compare4_celltype');
            const myChart_compare4_celltype_type = echarts.init(compare4_celltype_div);
            let option;
            option = {
              title:{
                text: 'celltype',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info4.celltype_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info4.celltype_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info4.celltype_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info4.celltype_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare4_celltype_type.setOption(option);
          }else {
            document.getElementById('compare4_celltype').style.display = 'none';
          }
          if (haveMajor){
            width = width + 400;
            let compare4_major_div = document.getElementById('compare4_major');
            const myChart_compare4_major_type = echarts.init(compare4_major_div);
            let option;
            option = {
              title:{
                text: 'celltype major',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info4.major_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info4.major_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info4.major_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info4.major_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare4_major_type.setOption(option);
          }else {
            document.getElementById('compare4_major').style.display = 'none';
          }
          if (haveMinor){
            width = width + 400;
            let compare4_minor_div = document.getElementById('compare4_minor');
            const myChart_compare4_minor_type = echarts.init(compare4_minor_div);
            let option;
            option = {
              title:{
                text: 'celltype minor',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info4.minor_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info4.minor_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info4.minor_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info4.minor_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare4_minor_type.setOption(option);
          }else {
            document.getElementById('compare4_minor').style.display = 'none';
          }
          if (haveSubset){
            width = width + 400;
            let compare4_subset_div = document.getElementById('compare4_subset');
            const myChart_compare4_subset_type = echarts.init(compare4_subset_div);
            let option;
            option = {
              title:{
                text: 'celltype subset',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info4.subset_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info4.subset_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info4.subset_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info4.subset_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare4_subset_type.setOption(option);
          }else {
            document.getElementById('compare4_subset').style.display = 'none';
          }
          document.getElementById('compare4_right').style.width = width + 'px';
          break;
        case 4:
          if (haveAnno){
            width = width + 400;
            let compare5_anno_type_div = document.getElementById('compare5_anno_type');
            const myChart_compare5_anno_type = echarts.init(compare5_anno_type_div);
            let option;
            option = {
              title:{
                text: 'annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info5.annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info5.annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info5.annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info5.annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare5_anno_type.setOption(option);
          }else {
            document.getElementById('compare5_anno_type').style.display = 'none';
          }
          if (haveFineAnno){
            width = width + 400;
            let compare5_fine_anno_type_div = document.getElementById('compare5_fine_anno_type');
            const myChart_compare5_fine_anno_type = echarts.init(compare5_fine_anno_type_div);
            let option;
            option = {
              title:{
                text: 'fine annotation type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info5.fine_annot_type_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info5.fine_annot_type_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info5.fine_annot_type_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info5.fine_annot_type_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare5_fine_anno_type.setOption(option);
          }else {
            document.getElementById('compare5_fine_anno_type').style.display = 'none';
          }
          if (haveClassification){
            width = width + 400;
            let compare5_classification_div = document.getElementById('compare5_classification');
            const myChart_compare5_classification_type = echarts.init(compare5_classification_div);
            let option;
            option = {
              title:{
                text: 'classification type',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info5.classification_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info5.classification_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info5.classification_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info5.classification_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare5_classification_type.setOption(option);
          }else {
            document.getElementById('compare5_classification').style.display = 'none';
          }
          if (haveCelltype){
            width = width + 400;
            let compare5_celltype_div = document.getElementById('compare5_celltype');
            const myChart_compare5_celltype_type = echarts.init(compare5_celltype_div);
            let option;
            option = {
              title:{
                text: 'celltype',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info5.celltype_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info5.celltype_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info5.celltype_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info5.celltype_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare5_celltype_type.setOption(option);
          }else {
            document.getElementById('compare5_celltype').style.display = 'none';
          }
          if (haveMajor){
            width = width + 400;
            let compare5_major_div = document.getElementById('compare5_major');
            const myChart_compare5_major_type = echarts.init(compare5_major_div);
            let option;
            option = {
              title:{
                text: 'celltype major',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info5.major_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info5.major_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info5.major_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info5.major_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare5_major_type.setOption(option);
          }else {
            document.getElementById('compare5_major').style.display = 'none';
          }
          if (haveMinor){
            width = width + 400;
            let compare5_minor_div = document.getElementById('compare5_minor');
            const myChart_compare5_minor_type = echarts.init(compare5_minor_div);
            let option;
            option = {
              title:{
                text: 'celltype minor',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info5.minor_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info5.minor_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info5.minor_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info5.minor_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare5_minor_type.setOption(option);
          }else {
            document.getElementById('compare5_minor').style.display = 'none';
          }
          if (haveSubset){
            width = width + 400;
            let compare5_subset_div = document.getElementById('compare5_subset');
            const myChart_compare5_subset_type = echarts.init(compare5_subset_div);
            let option;
            option = {
              title:{
                text: 'celltype subset',
                left: 'center'
              },
              dataset: {
                source: _this.echart_info5.subset_info.source
              },
              tooltip: {
                show: true,
                position: 'bottom'
              },
              visualMap: {
                type: 'piecewise',
                top: 'middle',
                right: 0,
                dimension: 0,
                seriesIndex: 0,
                pieces: _this.echart_info5.subset_info.tip,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
                },
              },
              grid: {
                right: 100
              },
              xAxis: {
                type: 'value',
                name: 'x',
                nameGap: 16,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'value',
                name: 'y',
                nameLocation: 'end',
                nameGap: 20,
                nameTextStyle: {
                  fontSize: 16
                },
                // max: 150,
                splitLine: {
                  show: false
                }
              },
              series: [{
                show: false,
                name: 'Detail',
                type: 'scatter',
                encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
                symbolSize: _this.echart_info5.subset_info.spotSize,
                // symbolSize: 10,
                itemStyle: {
                  // color: '#ff0000'
                  normal:{
                    color: function (p){
                      let index = _this.echart_info5.subset_info.types.indexOf(p.value[0])
                      return _this.COLOR_ALL[index]
                    }
                  }
                }
              }]
            }
            option && myChart_compare5_subset_type.setOption(option);
          }else {
            document.getElementById('compare5_subset').style.display = 'none';
          }
          document.getElementById('compare5_right').style.width = width + 'px';
          break;
      }
    },
    initEchart(my_div, index){
      let _this = this
      let _div = document.getElementById(my_div);
      let myChart = echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let echart_info
      switch (index) {
        case 0:
          echart_info = _this.echart_info1
          break;
        case 1:
          echart_info = _this.echart_info2
          break;
        case 2:
          echart_info = _this.echart_info3
          break;
        case 3:
          echart_info = _this.echart_info4
          break;
        case 4:
          echart_info = _this.echart_info5
          break;
      }
      let info
      if (_this.type_select[index] === 'domain'){
        info = echart_info.classification_info
      }else if (_this.type_select[index] === 'annotation'){
        info = echart_info.annot_type_info
      }else if (_this.type_select[index] === 'fine annotation'){
        info = echart_info.fine_annot_type_info
      }else if (_this.type_select[index] === 'cell type'){
        info = echart_info.celltype_info
      }else if (_this.type_select[index] === 'cell type major'){
        info = echart_info.celltype_major_info
      }else if (_this.type_select[index] === 'cell type minor'){
        info = echart_info.celltype_minor_info
      }else if (_this.type_select[index] === 'cell type subset'){
        info = echart_info.celltype_subset_info
      }else {
        info = {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      }
      let option;
      option = {
        title:{
          text: _this.type_select[index],
          left: 'center'
        },
        dataset: {
          source: info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          pieces: info.tip,
          formatter: function (value) {
            return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          },
        },
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index22 = info.types.indexOf(p.value[0])
                return _this.COLOR_ALL[index22]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    changeSummit() {
      let _this = this
      _this.Gene.length = 0
      for (let i = 0; i < _this.gene_json.length; i++){
        _this.Gene.push(_this.gene_json[i].gene)
      }
      for (let i = 0; i < 25; i++){
        _this.Expression[i].length = 0
      }
      for (let i = 0; i < _this.selectedDataset.length; i++){
        for (let j = 0; j < _this.Gene.length; j++){
          _this.$axios.get(
              'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/gene/echarts/'
              + _this.selectedDataset[i].datasetID + '/' + _this.selectedDataset[i].name + '/' + _this.Gene[j])
              .then(function (response){
                _this.Expression[i*5+j] = response.data.data
              })
        }
      }
      for (let i = 1; i <= _this.selectedDataset.length; i++){
        for (let j = 5; j > _this.Gene.length; j--) {
          let tempstr = "compare" + i + "_gene" + j;
          document.getElementById(tempstr).style.display = 'none'
        }
      }
      for (let i = 1; i <= _this.selectedDataset.length; i++){
        for (let j = 1; j <= _this.Gene.length; j++) {
          let tempstr = "compare" + i + "_gene" + j;
          document.getElementById(tempstr).style.display = 'block'
        }
      }
      setTimeout(() => {
        // console.log(_this.formData.Gene)
        // console.log(_this.SVG1.data)
        // console.log(_this.SVG2.data)
        _this.reload_echarts_data()
      },1000)
    },
    hideCompareIndex(index){
      document.getElementById('groundtruth' + index).style.display = 'none'
      document.getElementById('compare' + index + '_echart').style.display = 'none'
      document.getElementById('compare' + index + '_classification').style.display = 'none'
      document.getElementById('compare' + index + '_anno_type').style.display = 'none'
      document.getElementById('compare' + index + '_fine_anno_type').style.display = 'none'
      document.getElementById('compare' + index + '_celltype').style.display = 'none'
      document.getElementById('compare' + index + '_major').style.display = 'none'
      document.getElementById('compare' + index + '_minor').style.display = 'none'
      document.getElementById('compare' + index + '_subset').style.display = 'none'
    },
    changeSelect(index) {
      let _this = this
      _this.hideCompareIndex(index+1)
      if (_this.type_select[index] === 'image'){
        document.getElementById('groundtruth' + (index + 1)).style.display = 'block'
      }else if (_this.type_select[index] === 'domain'){
        document.getElementById('compare' + (index + 1) + '_classification').style.display = 'block'
      }else if (_this.type_select[index] === 'annotation'){
        document.getElementById('compare' + (index + 1) + '_anno_type').style.display = 'block'
      }else if (_this.type_select[index] === 'fine annotation'){
        document.getElementById('compare' + (index + 1) + '_fine_anno_type').style.display = 'block'
      }else if (_this.type_select[index] === 'cell type'){
        document.getElementById('compare' + (index + 1) + '_celltype').style.display = 'block'
      }else if (_this.type_select[index] === 'cell type major'){
        document.getElementById('compare' + (index + 1) + '_major').style.display = 'block'
      }else if (_this.type_select[index] === 'cell type minor'){
        document.getElementById('compare' + (index + 1) + '_minor').style.display = 'block'
      }else if (_this.type_select[index] === 'cell type subset'){
        document.getElementById('compare' + (index + 1) + '_subset').style.display = 'block'
      }
    },
    getMaxV(distributionInfo, dimension) {
      let max = 0
      for (let i=0;i<distributionInfo.length;i++) {
        if (max < Number(distributionInfo[i][dimension])){
          max = Number(distributionInfo[i][dimension])
        }
      }
      return max
    },
    getMinV(distributionInfo, dimension) {
      let min = 99999
      for (let i=0;i<distributionInfo.length;i++) {
        if (min > Number(distributionInfo[i][dimension])){
          min = Number(distributionInfo[i][dimension])
        }
      }
      return min
    },
    reload_echarts_data(){
      let _this = this
      let temp_Gene = []
      for (let i = 0; i < 5; i++){
        if (i < _this.Gene.length){
          temp_Gene.push(_this.Gene[i])
        }else {
          temp_Gene.push('')
        }
      }
      for (let i = 0; i < _this.selectedDataset.length; i++){
        for (let j = 0; j < _this.Gene.length; j++) {
          let tempstr = "compare" + (i+1) + "_gene" + (j+1);
          const myChart = echarts.getInstanceByDom(document.getElementById(tempstr));
          let option;
          option = {
            title: {
              text: temp_Gene[j],
            },
            visualMap: [
              {
                min: _this.getMinV(_this.Expression[i*5+j], 3),
                max: _this.getMaxV(_this.Expression[i*5+j], 3),
              }
            ],
            series: [
              {
                symbolSize: 5,
                data: _this.Expression[i*5+j],
                type: 'scatter'
              }
            ]
          };
          option && myChart.setOption(option);
        }
      }
    },
    add() {//动态添加input框
      if (this.gene_json.length >= 5){
        console.log(this.gene_json.length)
        return
      }
      this.gene_json.push({ gene: "" });
    },
    remove(){
      this.gene_json.pop()
    }
  }
}
</script>

<style scoped>
.container{
  background-color: #FFFFFF;
  width: 100%;
  height: 450px;
  display: flex;
  align-items: center;
}
.left{
  height: 450px;
  width: 450px;
  /*overflow-x: auto;*/
  overflow-y: auto;
  z-index: 99;
}
.right{
  height: 450px;
  flex: 1;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  /*display: inline;*/
  overflow-x: auto;
  /*overflow-y: auto;*/
  z-index: 99;
}
</style>
